// Vendor Libraries
import { ElementRef } from '@angular/core';
// Services & Interface
import { FundChartService } from 'ChartApp/ts/services/fund-chart.service';
import { ChartZoomService } from 'ChartApp/ts/features/charts-shared/services/chart-zoom.service';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
// Constants
import { CHART_FORMAT_NORMALIZED, FUND_CHART_SYSTEM_DEFAULT_STATE, VALID_FUND_CHART_DATE_ZOOM_OPTIONS, } from '../fundamental-chart/constants';
import { PERFORMANCE_CHART_CONFIGURABLE_OPTIONS } from 'ChartApp/ts/features/performance-chart/defaults';
import * as i0 from "@angular/core";
import * as i1 from "ChartApp/ts/services/fund-chart.service";
import * as i2 from "AccountsApp/ts/services/accounts.service";
import * as i3 from "@angular/common";
import * as i4 from "../fundamental-chart/components/fundamental-chart/fundamental-chart.component";
import * as i5 from "../fundamental-chart/components/fund-chart-date-zoom/fund-chart-date-zoom.component";
const _c0 = a0 => ({ top: a0 });
const _c1 = () => ({ list: "chart-control-inline" });
function PerformanceChartComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12)(2, "span", 13);
    i0.ɵɵelement(3, "span", 14);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(5, "div", 15)(6, "div", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const series_r1 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵstyleMap(i0.ɵɵinterpolate1("background-color: ", series_r1.color, ";"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", series_r1.longLabel, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", series_r1.val1 !== "" ? series_r1.val1 : "&nbsp");
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", series_r1.val2 !== "" ? series_r1.val2 : "&nbsp");
} }
function PerformanceChartComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, PerformanceChartComponent_div_4_div_1_Template, 7, 6, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const chart_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c0, ctx_r3.subchartOffsets[i_r3] + "px"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", chart_r2);
} }
function PerformanceChartComponent_ycn_fund_chart_date_zoom_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-fund-chart-date-zoom", 17);
    i0.ɵɵlistener("selectZoomOptionHandler", function PerformanceChartComponent_ycn_fund_chart_date_zoom_7_Template_ycn_fund_chart_date_zoom_selectZoomOptionHandler_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setZoom($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(3, _c1))("zoomOptions", ctx_r3.ZOOM_OPTIONS)("zoom", ctx_r3.state.zoom);
} }
/**
 *
 * Performance Chart Component
 *
 * required attributes:
 * calcs : list of calcs to display in the chart
 * chartTabUrl : URL of chart tab for security
 * securityIds : security_ids list
 *
 * optional:
 * userPreferenceKeys : state key > user preference key map, ex: { zoom: 'model_portfolios_performance_chart_zoom' }
 *        ** NOTE ** 'zoom' is the only possible user preference for this chart
 *
 */
export class PerformanceChartComponent {
    constructor(eltRef, fundChartService, accountsService) {
        this.eltRef = eltRef;
        this.fundChartService = fundChartService;
        this.accountsService = accountsService;
        this.additionalDataQueryParams = {};
        this.loadingChart = true;
        this.noDataClass = 'get-started-border';
        this.state = FUND_CHART_SYSTEM_DEFAULT_STATE;
        this.chartDataUrl = '';
        this.tooltipData = [];
        this.subchartOffsets = [];
        this.chartOptions = {};
        this.CHART_CONFIGURABLE_OPTIONS = PERFORMANCE_CHART_CONFIGURABLE_OPTIONS;
        this.USER = window.USER;
        this.additionalDataQueryParams = JSON.parse(this.eltRef.nativeElement.getAttribute('additionalDataQueryParams') ?? '{}');
        this.calcs = JSON.parse(this.eltRef.nativeElement.getAttribute('calcs'));
        this.chartTabUrl = this.eltRef.nativeElement.getAttribute('chartTabUrl');
        this.securityIds = JSON.parse(this.eltRef.nativeElement.getAttribute('securityIds'));
        const userPreferenceKeysString = this.eltRef.nativeElement.getAttribute('userPreferenceKeys');
        this.userPreferenceKeys = userPreferenceKeysString != null ? JSON.parse(userPreferenceKeysString) : undefined;
        this.userPreferences = {};
        this.ZOOM_OPTIONS = VALID_FUND_CHART_DATE_ZOOM_OPTIONS.filter((o) => o.value !== '1d');
    }
    ngOnInit() {
        if (this.userPreferenceKeys?.zoom != null) {
            this.accountsService.getUserPreferences().subscribe({
                next: (preferences) => {
                    this.userPreferences.zoom = preferences[this.userPreferenceKeys.zoom];
                },
                error: () => { },
                complete: () => {
                    this.setUpState();
                },
            });
        }
        else {
            this.setUpState();
        }
    }
    setUpState() {
        // Set up calcs
        const calcs = this.calcs.map((calc) => ({
            id: calc,
            include: true,
        }));
        // Set up securities
        const securities = this.securityIds.map((id) => {
            return { id, include: true, type: 'security' };
        });
        const initialState = {
            calcs,
            securities,
            format: CHART_FORMAT_NORMALIZED,
            zoom: this.userPreferences.zoom,
        };
        this.state = { ...FUND_CHART_SYSTEM_DEFAULT_STATE, ...initialState };
        this.chartDataUrl = this.getChartDataUrl();
    }
    setZoom(zoomOption) {
        this.state.zoom = zoomOption.value;
        this.chartDataUrl = this.getChartDataUrl();
        if (this.USER.authenticated && this.userPreferenceKeys?.zoom != null) {
            const zoomPreferenceParams = {
                [this.userPreferenceKeys.zoom]: zoomOption.value,
            };
            this.accountsService.putUserPreferences(zoomPreferenceParams).subscribe({
                error: () => {
                    // Do nothing if we get an error while trying to set preferences for an anonymous user
                },
            });
        }
    }
    getChartDataUrl() {
        // Need to use a stubbed domain for URL class. Otherwise we have to encode the params by ourselves
        const dataUrl = new URL(this.fundChartService.getChartDataUrl(this.state), 'http://localhost');
        Object.entries(this.additionalDataQueryParams).forEach(([key, val]) => {
            dataUrl.searchParams.set(key, val);
        });
        return `${dataUrl.pathname}${dataUrl.search}`;
    }
    tooltipDataHandler(tooltipData) {
        this.tooltipData = tooltipData;
    }
    subchartOffsetsHandler(subchartOffsets) {
        this.subchartOffsets = subchartOffsets;
    }
    chartDataHandler(chartData) {
        this.loadingChart = !(chartData && Array.isArray(chartData.chart_data) && chartData.chart_data.length > 0);
    }
    goToFundChartTab() {
        const queryParams = this.fundChartService.getChartDataUrlQuery(this.state);
        window.location.href = `${this.chartTabUrl}#/?${queryParams}`;
    }
}
PerformanceChartComponent.ɵfac = function PerformanceChartComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PerformanceChartComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.FundChartService), i0.ɵɵdirectiveInject(i2.AccountsService)); };
PerformanceChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerformanceChartComponent, selectors: [["ycn-performance-chart"]], inputs: { calcs: "calcs", chartTabUrl: "chartTabUrl", securityIds: "securityIds", userPreferenceKeys: "userPreferenceKeys" }, standalone: false, features: [i0.ɵɵProvidersFeature([ChartZoomService])], decls: 9, vars: 6, consts: [[1, "panel-content"], [1, "chart-cover", "chart-tall"], [1, "chart-interactive"], [1, "chart-item", "user-select-none"], ["class", "chart-legend col-lg-6", 3, "ngStyle", 4, "ngFor", "ngForOf"], [1, "chart-wrap"], [1, "chart-canvas"], [3, "customCssClasses", "zoomOptions", "zoom", "selectZoomOptionHandler", 4, "ngIf"], [1, "chart-canvas", "d-flex", "flex-column", 3, "chartDataHandler", "chartClickHandler", "subchartOffsetsHandler", "tooltipDataHandler", "chartOptions", "configurableOptions", "chartDataUrl", "noDataClass"], [1, "chart-legend", "col-lg-6", 3, "ngStyle"], ["class", "chart-legend-item", 4, "ngFor", "ngForOf"], [1, "chart-legend-item"], [1, "chart-legend-item-name"], [1, "chart-legend-item-title", "bullet-color"], [1, "chart-bullet-point"], [1, "chart-legend-item-date", 3, "textContent"], [1, "chart-legend-item-value", 3, "textContent"], [3, "selectZoomOptionHandler", "customCssClasses", "zoomOptions", "zoom"]], template: function PerformanceChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3);
        i0.ɵɵtemplate(4, PerformanceChartComponent_div_4_Template, 2, 4, "div", 4);
        i0.ɵɵelementStart(5, "div", 5)(6, "div", 6);
        i0.ɵɵtemplate(7, PerformanceChartComponent_ycn_fund_chart_date_zoom_7_Template, 1, 4, "ycn-fund-chart-date-zoom", 7);
        i0.ɵɵelementStart(8, "ycn-fundamental-chart", 8);
        i0.ɵɵlistener("chartDataHandler", function PerformanceChartComponent_Template_ycn_fundamental_chart_chartDataHandler_8_listener($event) { return ctx.chartDataHandler($event); })("chartClickHandler", function PerformanceChartComponent_Template_ycn_fundamental_chart_chartClickHandler_8_listener() { return ctx.goToFundChartTab(); })("subchartOffsetsHandler", function PerformanceChartComponent_Template_ycn_fundamental_chart_subchartOffsetsHandler_8_listener($event) { return ctx.subchartOffsetsHandler($event); })("tooltipDataHandler", function PerformanceChartComponent_Template_ycn_fundamental_chart_tooltipDataHandler_8_listener($event) { return ctx.tooltipDataHandler($event); });
        i0.ɵɵelementEnd()()()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngForOf", ctx.tooltipData);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.loadingChart);
        i0.ɵɵadvance();
        i0.ɵɵproperty("chartOptions", ctx.chartOptions)("configurableOptions", ctx.CHART_CONFIGURABLE_OPTIONS)("chartDataUrl", ctx.chartDataUrl)("noDataClass", ctx.noDataClass);
    } }, dependencies: [i3.NgForOf, i3.NgIf, i3.NgStyle, i4.FundamentalChartComponent, i5.FundChartDateZoomComponent], encapsulation: 2 });
